import { SecondLevelShareByDistrict } from "./SecondLevelShareByDistrict"

export const ShareByDistrict = {
  "columns": 5,
  "rows": 1,
  "visual": {
    "id": 4,
    "type": "treemap",
    "colorTheme": "colorTheme1",
    "title": "Share by District",
    "xAxis": "",
    "yAxis": "",
    "binding": {
      "data": {
        "title": 'DistrictGroupCode',
        "value": 'Share',
        "tooltip": 'ActualSales',
        "currency": true,
        "percent": true,
        "endpoint": "N31",
        "filter": {
          "show": false,
          "local": ["DistrictGroupCode"],
        },
        "parameters": [
          { "key": "FromMonth", "value": "2024" },
          { "key": "FromYear", "value": "1" },
          { "key": "ToMonth", "value": "2024" },
          { "key": "ToYear", "value": "1" },
          { "key": "ConfigTypeCode", "value": "" },
          { "key": "DistrictGroupCode", "value": '' }
        ]
      },
      "context": {
        "point": {
          "onClick": SecondLevelShareByDistrict
        }
      }
    }
  }
}
